import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClinical = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Nav / Trial ",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_4482_19510",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Bounding box",
				width: 24,
				height: 24,
				fill: "#D9D9D9"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_4482_19510)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "health_metrics",
				d: "M7.50003 21.4231V16.5001H2.57703V7.50015H7.50003V2.57715H16.5V7.50015H21.423V16.5001H16.5V21.4231H7.50003ZM4.07703 11.2501H9.00003C9.12819 11.2501 9.24644 11.2806 9.35478 11.3414C9.46311 11.4024 9.54936 11.4836 9.61353 11.5849L10.777 13.3174L12.2905 8.77715C12.3444 8.62198 12.4347 8.4954 12.5615 8.3974C12.6885 8.29923 12.834 8.25015 12.998 8.25015C13.1244 8.25015 13.2444 8.28115 13.358 8.34315C13.4715 8.40515 13.5599 8.48573 13.623 8.5849L15.3903 11.2501H19.923V9.00015H15V4.07715H9.00003V9.00015H4.07703V11.2501ZM9.00003 19.9231H15V15.0001H19.923V12.7501H15C14.8749 12.7501 14.7559 12.7182 14.6433 12.6544C14.5306 12.5907 14.4367 12.5079 14.3615 12.4059L13.223 10.6829L11.7095 15.2231C11.6557 15.3783 11.5612 15.5049 11.426 15.6029C11.2907 15.7011 11.1401 15.7501 10.9743 15.7501C10.8466 15.7501 10.7286 15.7197 10.6203 15.6589C10.5119 15.5979 10.4257 15.5167 10.3615 15.4154L8.58478 12.7501H4.07703V15.0001H9.00003V19.9231Z",
				fill: "currentColor"
			})
		})]
	})
});
export default SvgClinical;
